<template>
  <v-icon :color="color">
    star
  </v-icon>
</template>

<script>
export default {
  name: 'DataTableStarRow',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    color() {
      return this.value ? 'yellow' : '';
    },
  },
};
</script>
